import { StyleProp, TextProps, TextStyle } from 'react-native'
import { VariantProps } from 'class-variance-authority'
import { sTypography } from './styles'

type Variants = VariantProps<typeof sTypography>

export type TypographyVariant = Variants['variant']

export type TypographyProps = {
  children?: React.ReactNode
  className?: string
  style?: StyleProp<TextStyle>
  color?: string
} & Variants &
  TextProps

export const getStrong = (
  variant: TypographyProps['variant']
): TypographyProps['variant'] => {
  if (
    variant === 'XL' ||
    variant === 'LG' ||
    variant === 'MD' ||
    variant === 'SM' ||
    variant === 'XS'
  ) {
    return `${variant}B`
  }
  return variant
}
